export enum GOVERNMENT_PLAN_STATUS {
    IN_PROGRESS = "em andamento",
    COMPLETED = "concluido",
    COMPLETED_LATE = "concluido com atraso",
    CANCELED = "cancelado",
}
